"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  xs: '0 7px 13px rgba(0,0,0,0.02)',
  sm: '0 4px 10px rgba(0,0,0,0.05)',
  md: '0 8px 20px rgba(0,0,0,0.09)',
  lg: '0 16px 32px rgba(0,0,0,0.09)'
};
exports.default = _default;